import { Button, FormContainer } from 'components/ui'
import { Form, Formik } from 'formik'
import React from 'react'
import InputField from './InputField'
import { useDispatch } from 'react-redux'
import { setDialogOpen } from 'store/header/headerSlice'
import { cloneDeep } from 'lodash'
import * as Yup from 'yup'
import { createCity } from 'services/cityListService'
import { showToast } from 'utils/toast'
const validationSchema = Yup.object().shape({
    city_name: Yup.string()
        .required('City Name Required ')
        .max(30, 'City name cannot exceed 30 characters'),
    country_id: Yup.string().required('Please Select Country'),
    // state_id: Yup.string().required('Please Select State'),
})
const CityForm = () => {
    const dispatch = useDispatch()
    const onDialogClose = () => {
        dispatch(setDialogOpen(false))
    }
    const onSubmit = async (values, setSubmitting, resetForm) => {
        setSubmitting(true)
        try {
            const response = await createCity(values)
            console.log('response', response)
            if (response) {
                setSubmitting(false)
                showToast({
                    type: 'success',
                    message: 'City Created Successfully',
                })
                dispatch(setDialogOpen(false))
            }
        } catch (err) {
            setSubmitting(false)
            showToast({
                type: 'warning',
                message: err.toString(),
            })
        }
    }
    return (
        <Formik
            enableReinitialize
            initialValues={{
                city_name: '',
                country_id: '',
                state_id: '',
                country_code: '',
            }}
            validationSchema={validationSchema}
            onSubmit={(values, { resetForm, setSubmitting }) => {
                const formData = cloneDeep(values)
                delete formData.country_code
                console.log('formCountryData', formData)
                formData.state_id = formData.state_id ? formData.state_id : null
                onSubmit(formData, setSubmitting, resetForm)
            }}
        >
            {({ errors, touched, values, isSubmitting }) => {
                return (
                    <>
                        <Form>
                            <FormContainer>
                                <InputField
                                    errors={errors}
                                    touched={touched}
                                    values={values}
                                />
                                <div className="text-right mt-6">
                                    <Button
                                        className="ltr:mr-2 rtl:ml-2"
                                        variant="plain"
                                        onClick={onDialogClose}
                                    >
                                        Cancel
                                    </Button>
                                    <Button
                                        variant="solid"
                                        type="submit"
                                        loading={isSubmitting}
                                    >
                                        Submit
                                    </Button>
                                </div>
                            </FormContainer>
                        </Form>
                    </>
                )
            }}
        </Formik>
    )
}

export default CityForm
